/* eslint-disable */
import React, { Component } from 'react'
import ListVideoPlayCounters from '../../Services/Queries/ListVideoPlayCounters'
import { Button, Table, Modal } from 'react-bootstrap'
import { DateRangePicker } from 'react-date-range'
import Select from 'react-select'
import ListDistricts from '../../Services/Queries/ListDistricts'
import GetContentCategories from '../../Services/Queries/GetContentCategories'
import { Auth } from 'aws-amplify'
import {
	videoPlayCountersAPLocations,
	videoPlayCountersContentHeadings,
	videoPlayCountersEnglishContentHeadings,
	videoPlayCountersenglishVideoHeadings,
	videoPlayCountersfeedTypeOptions,
	videoPlayCountersHeadings,
	videoPlayCountersHindiContentHeadings,
	videoPlayCountershindiVideoHeadings,
	videoPlayCountershyderabadiVideoHeadings,
	videoPlayCounterslocationContentHeadings,
	videoPlayCounterslocationVideoHeadings,
	videoPlayCountersloginHeadings,
	videoPlayCountersonlyMusicVideoHeadings,
	videoPlayCountersOtherOptions,
	videoPlayCountersTeluguContentHeadings,
	videoPlayCountersteluguVideoHeadings,
	videoPlayCountersTGLocations,
	videoPlayCountersVideoHeadings,
	weekdays,
} from '../Data/StaticData'
import Header from '../header'
import Spinner from '../header/Spinner'
import ListVideosByLanguage from './ListVideosByLanguage'
import { DefinedPermissions } from '../Constants/Permissions'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import ListJobsCounters from './ListJobsCounters'

class VideoPlayCounters extends React.Component {
	constructor(props) {
		super(props)
		this.dayName = weekdays
		this.state = {
			videoPlayCounters: [],
			headings: videoPlayCountersHeadings,
			contentHeadings: videoPlayCountersContentHeadings,
			teluguContentHeadings: videoPlayCountersTeluguContentHeadings,
			hindiContentHeadings: videoPlayCountersHindiContentHeadings,
			englishContentHeadings: videoPlayCountersEnglishContentHeadings,
			videoHeadings: videoPlayCountersVideoHeadings,
			teluguVideoHeadings: videoPlayCountersteluguVideoHeadings,
			hindiVideoHeadings: videoPlayCountershindiVideoHeadings,
			englishVideoHeadings: videoPlayCountersenglishVideoHeadings,
			onlyMusicVideoHeadings: videoPlayCountersonlyMusicVideoHeadings,
			hyderabadiVideoHeadings: videoPlayCountershyderabadiVideoHeadings,
			locationContentHeadings: videoPlayCounterslocationContentHeadings,
			locationVideoHeadings: videoPlayCounterslocationVideoHeadings,
			loginHeadings: videoPlayCountersloginHeadings,

			feedTypeOptions: videoPlayCountersfeedTypeOptions,
			selectedFeedType: 'Content',
			dayName: '',
			displayActiveUsersCount: false,
			loggedInUserPermissions: [],
			languageOptions: [
				{
					label: 'English',
					value: 'En',
					id: 0,
				},
				{
					label: 'Telugu',
					value: 'Te',
					id: 1,
				},
				{
					label: 'Hindi',
					value: 'Hi',
					id: 2,
				},
			],
			selectedLang: '',
			showDatePicker: false,
			showDatePickerAtFromDate: false,
			showDatePickerAtToDate: false,
			dateSelection: {
				onDate: '',
			},
			dateRangeSelection: {
				fromDate: '',
				toDate: '',
			},
			dateRangeFilter: false,
			filtered: false,
			dataFound: false,
			isfilteredWithLocations: false,
			selectedState: '',
			selectedDistrict: '',
			TGLocations: videoPlayCountersTGLocations,
			APLocations: videoPlayCountersAPLocations,
			OtherOptions: videoPlayCountersOtherOptions,
			categories: [],
			contentCategory: '',
			modalVisible: false,
			summarizedBy: '',
			loading: true,
		}
	}

	changeAppLanguage = e => {
		const language = e.target.value
		const { appLanguage } = this.state
		if (appLanguage != language) {
			this.setState(
				{
					appLanguage: language,
					selectedLang: language,
					filtered: true,
					videoPlayCounters: [],
				},
				() => {
					this.ListVideoPlayCounters()
				},
			)
			localStorage.setItem('appLanguage', language)
		}
	}

	componentDidMount = async () => {
		let appLanguage = localStorage.getItem('appLanguage')
		appLanguage = appLanguage ? appLanguage : 'Telugu'
		const permissionInput = {
			mobileNumber: Auth.user.attributes.phone_number,
		}
		const userPermissions = await GetUserPermissions(permissionInput)
		const permissions = []
		const permissionsArr = []
		if (userPermissions && userPermissions.userRolesAndPermissions) {
			userPermissions.userRolesAndPermissions.map(item => {
				permissions.push(...item.permissions)
			})
			permissions.map(permission => {
				permissionsArr.push(permission.name)
			})
		}

		const displayActiveUsersCount = permissionsArr.includes(
			DefinedPermissions.displayActiveUsersCount,
		)
		this.setState(
			{
				appLanguage,
				selectedLang: appLanguage,
				loggedInUserPermissions: permissionsArr,
				displayActiveUsersCount,
			},
			async () => {
				const data = await ListDistricts()
				const categoriesData = await GetContentCategories()
				this.setState({ categories: categoriesData.categoriesConfig })
				const TG = []
				const AP = []
				let index = 0
				let index1 = 0
				for (let i = 0;i < data.items.length;i++) {
					if (data.items[i].stateCodec === 'TG') {
						TG[index] = data.items[i]
						TG[index].label = data.items[i].district
						index += 1
					} else {
						AP[index1] = data.items[i]
						AP[index1].label = data.items[i].district
						index1 += 1
					}
				}

				this.setState({
					TGLocations: [...this.state.TGLocations, ...TG],
					APLocations: [...this.state.APLocations, ...AP],
				})
				await this.ListVideoPlayCounters()
			},
		)
	}

	ListVideoPlayCounters = async () => {
		this.setState({ loading: true })
		const input = {
			feedType: this.state.selectedFeedType,
		}
		let filtered
		if (
			(this.state.dateRangeSelection.fromDate !== '' &&
				this.state.dateRangeSelection.toDate !== '') ||
			this.state.dateSelection.onDate !== '' ||
			this.state.dayName !== '' ||
			this.state.selectedState !== '' ||
			this.state.selectedLang !== ''
		) {
			filtered = true
		} else {
			filtered = false
		}

		if (filtered === true) {
			input.filters = {}
			if (this.state.selectedLang !== '') {
				input.filters.language = this.state.selectedLang
			}

			if (this.state.dayName !== '') {
				input.filters.Day = this.state.dayName
			}

			if (this.state.dateRangeFilter === true) {
				input.filters.date = {}
				if (this.state.dateRangeSelection.fromDate !== '') {
					input.filters.date.fromDate = this.state.dateRangeSelection.fromDate
				}

				if (this.state.dateRangeSelection.toDate !== '') {
					input.filters.date.toDate = this.state.dateRangeSelection.toDate
				}
			}

			if (this.state.dateSelection.onDate !== '') {
				input.filters.onDate = this.state.dateSelection.onDate
			}

			if (this.state.selectedState !== '') {
				input.filters.state = this.state.selectedState
			}

			if (this.state.selectedDistrict !== '') {
				input.filters.district = this.state.selectedDistrict
			}
		}

		console.log(input, 'input firstt========')
		const videoPlayCounters = await ListVideoPlayCounters(input)
		console.log(videoPlayCounters, 'videoPlayCounters=====')
		if (
			videoPlayCounters.items !== null &&
			videoPlayCounters.items != undefined &&
			videoPlayCounters.items.length > 0
		) {
			this.setState({ dataFound: true })
		} else {
			this.setState({ dataFound: false })
		}

		this.setState({
			videoPlayCounters: videoPlayCounters.items,
			loading: false,
		})
	}

	renderContentTable = (contentHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{contentHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row => this.renderContentTableRow(row))}
			</tbody>
		</Table>
	)

	renderContentTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		// 2021/07/30
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{date}</td>
				<td className='tdCellStyle'>
					{this.state.appLanguage == 'Telugu'
						? item.noOfTeArticlesPublished
						: item.noOfEnArticlesPublished}
				</td>
				{this.state.displayActiveUsersCount ? (
					<td className='tdCellStyle'>
						{this.state.appLanguage == 'Telugu'
							? item.activeUsersTelugu
							: item.activeUsersEnglish}
					</td>
				) : (
					''
				)}
				<td className='tdCellStyle'>{item.Telugu_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_ShortByte_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_views}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_views}</td>

				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Telugu_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Telugu_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_SlideShow_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Hindi_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Hindi_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_views}
				</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_views}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_liveNews_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_liveNews_views}</td>

				<td className='tdCellStyle'>{item.English_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.English_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.English_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.TopStories}</td>
				<td className='tdCellStyle'>{item.India}</td>
				<td className='tdCellStyle'>{item.Telangana}</td>
				<td className='tdCellStyle'>{item.AP}</td>
				<td className='tdCellStyle'>{item.World}</td>
				<td className='tdCellStyle'>{item.Business}</td>
				<td className='tdCellStyle'>{item.Technology}</td>
				<td className='tdCellStyle'>{item.Sports}</td>
				<td className='tdCellStyle'>{item.Lifestyle}</td>
				<td className='tdCellStyle'>{item.Careers}</td>
				<td className='tdCellStyle'>{item.Health}</td>
				<td className='tdCellStyle'>{item.Entertainment_English}</td>
				<td className='tdCellStyle'>{item.Entertainment_Telugu}</td>
				<td className='tdCellStyle'>{item.TeluguMovies}</td>
				<td className='tdCellStyle'>{item.BollyWood}</td>
				<td className='tdCellStyle'>{item.Travel}</td>
				<td className='tdCellStyle'>{item.Science}</td>
				<td className='tdCellStyle'>{item.Politics}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderVideoTable = (videoHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{videoHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row => this.renderVideoTableRow(row))}
			</tbody>
		</Table>
	)

	renderVideoTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{date}</td>
				<td className='tdCellStyle'>{item.Telugu_Video_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Video_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Telugu_Video_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Video_follows}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Video_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Video_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Video_views}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Video_follows}</td>
				<td className='tdCellStyle'>{item.Hindi_Video_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Video_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Hindi_Video_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Video_follows}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Video_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Video_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Video_views}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Video_follows}</td>
				<td className='tdCellStyle'>{item.English_Video_likes}</td>
				<td className='tdCellStyle'>{item.English_Video_shares}</td>
				<td className='tdCellStyle'>{item.English_Video_downloads}</td>
				<td className='tdCellStyle'>{item.English_Video_views}</td>
				<td className='tdCellStyle'>{item.English_Video_follows}</td>
				<td className='tdCellStyle'>{item.Guest_English_Video_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Video_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Guest_English_Video_views}</td>
				<td className='tdCellStyle'>{item.Guest_English_Video_follows}</td>
				<td className='tdCellStyle'>{item.OnlyMusic_Video_likes}</td>
				<td className='tdCellStyle'>{item.OnlyMusic_Video_shares}</td>
				<td className='tdCellStyle'>{item.OnlyMusic_Video_downloads}</td>
				<td className='tdCellStyle'>{item.OnlyMusic_Video_views}</td>
				<td className='tdCellStyle'>{item.OnlyMusic_Video_follows}</td>
				<td className='tdCellStyle'>{item.Guest_OnlyMusic_Video_likes}</td>
				<td className='tdCellStyle'>{item.Guest_OnlyMusic_Video_shares}</td>
				<td className='tdCellStyle'>{item.Guest_OnlyMusic_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Guest_OnlyMusic_Video_views}</td>
				<td className='tdCellStyle'>{item.Guest_OnlyMusic_Video_follows}</td>
				<td className='tdCellStyle'>{item.Hyderabadi_Video_likes}</td>
				<td className='tdCellStyle'>{item.Hyderabadi_Video_shares}</td>
				<td className='tdCellStyle'>{item.Hyderabadi_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Hyderabadi_Video_views}</td>
				<td className='tdCellStyle'>{item.Hyderabadi_Video_follows}</td>
				<td className='tdCellStyle'>{item.Guest_Hyderabadi_Video_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hyderabadi_Video_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hyderabadi_Video_downloads}</td>
				<td className='tdCellStyle'>{item.Guest_Hyderabadi_Video_views}</td>
				<td className='tdCellStyle'>{item.Guest_Hyderabadi_Video_follows}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderTeluguContentTable = (teluguContentHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{teluguContentHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row =>
						this.renderTeluguContentTableRow(row),
					)}
			</tbody>
		</Table>
	)

	renderTeluguContentTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{date}</td>
				<td className='tdCellStyle'>
					{this.state.appLanguage == 'Telugu'
						? item.noOfTeArticlesPublished
						: item.noOfEnArticlesPublished}
				</td>
				{this.state.displayActiveUsersCount ? (
					<td className='tdCellStyle'>
						{this.state.appLanguage == 'Telugu'
							? item.activeUsersTelugu
							: item.activeUsersEnglish}
					</td>
				) : (
					''
				)}
				<td className='tdCellStyle'>{item.Telugu_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_ShortByte_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_liveNews_views}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_liveNews_views}</td>

				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Telugu_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Telugu_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_SlideShow_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.Telugu_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Telugu_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Telugu_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.TopStories}</td>
				<td className='tdCellStyle'>{item.India}</td>
				<td className='tdCellStyle'>{item.Telangana}</td>
				<td className='tdCellStyle'>{item.AP}</td>
				<td className='tdCellStyle'>{item.World}</td>
				<td className='tdCellStyle'>{item.Business}</td>
				<td className='tdCellStyle'>{item.Technology}</td>
				<td className='tdCellStyle'>{item.Sports}</td>
				<td className='tdCellStyle'>{item.Lifestyle}</td>
				<td className='tdCellStyle'>{item.Careers}</td>
				<td className='tdCellStyle'>{item.Health}</td>
				<td className='tdCellStyle'>{item.Entertainment_English}</td>
				<td className='tdCellStyle'>{item.Entertainment_Telugu}</td>
				<td className='tdCellStyle'>{item.TeluguMovies}</td>
				<td className='tdCellStyle'>{item.BollyWood}</td>
				<td className='tdCellStyle'>{item.Travel}</td>
				<td className='tdCellStyle'>{item.Science}</td>
				<td className='tdCellStyle'>{item.Politics}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderHindiContentTable = (hindiContentHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{hindiContentHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row =>
						this.renderHindiContentTableRow(row),
					)}
			</tbody>
		</Table>
	)

	renderHindiContentTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{date}</td>
				<td className='tdCellStyle'>
					{this.state.appLanguage == 'Telugu'
						? item.noOfTeArticlesPublished
						: item.noOfEnArticlesPublished}
				</td>
				{this.state.displayActiveUsersCount ? (
					<td className='tdCellStyle'>
						{this.state.appLanguage == 'Telugu'
							? item.activeUsersTelugu
							: item.activeUsersEnglish}
					</td>
				) : (
					''
				)}
				<td className='tdCellStyle'>{item.Hindi_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Hindi_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Hindi_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.Hindi_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_Hindi_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_Hindi_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.TopStories}</td>
				<td className='tdCellStyle'>{item.India}</td>
				<td className='tdCellStyle'>{item.Telangana}</td>
				<td className='tdCellStyle'>{item.AP}</td>
				<td className='tdCellStyle'>{item.World}</td>
				<td className='tdCellStyle'>{item.Business}</td>
				<td className='tdCellStyle'>{item.Technology}</td>
				<td className='tdCellStyle'>{item.Sports}</td>
				<td className='tdCellStyle'>{item.Lifestyle}</td>
				<td className='tdCellStyle'>{item.Careers}</td>
				<td className='tdCellStyle'>{item.Health}</td>
				<td className='tdCellStyle'>{item.Entertainment_English}</td>
				<td className='tdCellStyle'>{item.Entertainment_Telugu}</td>
				<td className='tdCellStyle'>{item.TeluguMovies}</td>
				<td className='tdCellStyle'>{item.BollyWood}</td>
				<td className='tdCellStyle'>{item.Travel}</td>
				<td className='tdCellStyle'>{item.Science}</td>
				<td className='tdCellStyle'>{item.Politics}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderEnglishContentTable = (englishContentHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{englishContentHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row =>
						this.renderEnglishContentTableRow(row),
					)}
			</tbody>
		</Table>
	)

	renderEnglishContentTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{date}</td>
				<td className='tdCellStyle'>
					{this.state.appLanguage == 'Telugu'
						? item.noOfTeArticlesPublished
						: item.noOfEnArticlesPublished}
				</td>
				{this.state.displayActiveUsersCount ? (
					<td className='tdCellStyle'>
						{this.state.appLanguage == 'Telugu'
							? item.activeUsersTelugu
							: item.activeUsersEnglish}
					</td>
				) : (
					''
				)}
				<td className='tdCellStyle'>{item.English_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Story_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Story_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Story_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_ShortByte_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_ShortByte_views}
				</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_liveNews_views}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_liveNews_likes}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_liveNews_shares}
				</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_liveNews_views}</td>

				<td className='tdCellStyle'>{item.English_Content_CoverStory_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_CoverStory_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_CoverStory_views}</td>
				<td className='tdCellStyle'>
					{item.English_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_CoverStory_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Mcq_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Mcq_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Mcq_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_SlideShow_views}</td>
				<td className='tdCellStyle'>
					{item.English_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_likes}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_shares}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_views}
				</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_SlideShow_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_views}</td>
				<td className='tdCellStyle'>{item.English_Content_Poll_watchAnalytics}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_likes}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_shares}</td>
				<td className='tdCellStyle'>{item.Guest_English_Content_Poll_views}</td>
				<td className='tdCellStyle'>
					{item.Guest_English_Content_Poll_watchAnalytics}
				</td>
				<td className='tdCellStyle'>{item.TopStories}</td>
				<td className='tdCellStyle'>{item.India}</td>
				<td className='tdCellStyle'>{item.Telangana}</td>
				<td className='tdCellStyle'>{item.AP}</td>
				<td className='tdCellStyle'>{item.World}</td>
				<td className='tdCellStyle'>{item.Business}</td>
				<td className='tdCellStyle'>{item.Technology}</td>
				<td className='tdCellStyle'>{item.Sports}</td>
				<td className='tdCellStyle'>{item.Lifestyle}</td>
				<td className='tdCellStyle'>{item.Careers}</td>
				<td className='tdCellStyle'>{item.Health}</td>
				<td className='tdCellStyle'>{item.Entertainment_English}</td>
				<td className='tdCellStyle'>{item.Entertainment_Telugu}</td>
				<td className='tdCellStyle'>{item.TeluguMovies}</td>
				<td className='tdCellStyle'>{item.BollyWood}</td>
				<td className='tdCellStyle'>{item.Travel}</td>
				<td className='tdCellStyle'>{item.Science}</td>
				<td className='tdCellStyle'>{item.Politics}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderLocationContentTable = (locationContentHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{locationContentHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row =>
						this.renderLocationContentTableRow(row),
					)}
			</tbody>
		</Table>
	)

	renderLocationContentTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{item.Date}</td>
				<td className='tdCellStyle'>{item.State}</td>
				<td className='tdCellStyle'>{item.District}</td>
				<td className='tdCellStyle'>{item.contentType}</td>
				<td className='tdCellStyle'>{item.likes}</td>
				<td className='tdCellStyle'>{item.views}</td>
				<td className='tdCellStyle'>{item.shares}</td>
				<td className='tdCellStyle'>{item.outlinks}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderLocationVideoTable = (locationVideoHeadings, videoPlayCounters) => (
		<Table striped bordered hover>
			<thead>
				<tr>
					{locationVideoHeadings.map(head => (
						<>
							{head == 'Active Users' ? (
								this.state.displayActiveUsersCount ? (
									<th className='tableRowStyle'>{head}</th>
								) : (
									''
								)
							) : (
								<th className='tableRowStyle'>{head}</th>
							)}
						</>
					))}
				</tr>
			</thead>
			<tbody>
				{videoPlayCounters &&
					videoPlayCounters.map(row =>
						this.renderLocationVideoTableRow(row),
					)}
			</tbody>
		</Table>
	)

	renderLocationVideoTableRow = item => {
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		return (
			<tr>
				<td className='tdCellStyle'>{item.Date}</td>
				<td className='tdCellStyle'>{item.State}</td>
				<td className='tdCellStyle'>{item.District}</td>
				<td className='tdCellStyle'>{item.likes}</td>
				<td className='tdCellStyle'>{item.views}</td>
				<td className='tdCellStyle'>{item.shares}</td>
				<td className='tdCellStyle'>{item.downloads}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderContentCategoriesTable = (contentCategory, videoPlayCounters) => {
		const contentCategoryHeadings = []
		contentCategoryHeadings[0] = 'Date'
		contentCategoryHeadings[1] = 'noOfArticlesPublished'
		contentCategoryHeadings[2] = contentCategory ? contentCategory : null
		contentCategoryHeadings[3] = contentCategoryHeadings[2] ? 'Day' : null
		if (contentCategoryHeadings.length === 4) {
			return (
				<Table striped bordered hover>
					<thead>
						<tr>
							{contentCategoryHeadings.map(head => (
								<>
									{head == 'Active Users' ? (
										this.state.displayActiveUsersCount ? (
											<th className='tableRowStyle'>{head}</th>
										) : (
											''
										)
									) : (
										<th className='tableRowStyle'>{head}</th>
									)}
								</>
							))}
						</tr>
					</thead>
					<tbody>
						{videoPlayCounters &&
							videoPlayCounters.map(row =>
								this.renderContentCategoriesTableRow(row, contentCategory),
							)}
					</tbody>
				</Table>
			)
		}

		return true
	}

	renderContentCategoriesTableRow = (item, contentCategory) => {
		const date = item.SK
			? item.SK.split('/')[2] +
			'/' +
			item.SK.split('/')[1] +
			'/' +
			item.SK.split('/')[0]
			: null
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null
		const selectedCategory =
			contentCategory === 'Top Stories'
				? 'TopStories'
				: contentCategory === 'Entertainment(English)'
					? 'Entertainment_English'
					: contentCategory === 'Entertainment(Telugu)'
						? 'Entertainment_Telugu'
						: contentCategory === 'Telugu Movies'
							? 'TeluguMovies'
							: contentCategory
		if (item.hasOwnProperty(selectedCategory)) {
			return (
				<tr>
					<td className='tdCellStyle'>{date}</td>
					<td className='tdCellStyle'>
						{this.state.appLanguage == 'Telugu'
							? item.noOfTeArticlesPublished
							: item.noOfEnArticlesPublished}
					</td>
					{this.state.displayActiveUsersCount ? (
						<td className='tdCellStyle'>
							{this.state.appLanguage == 'Telugu'
								? item.activeUsersTelugu
								: item.activeUsersEnglish}
						</td>
					) : (
						''
					)}
					<td className='tdCellStyle'>{item[selectedCategory]}</td>
					<td className='tdCellStyle'>{day}</td>
				</tr>
			)
		}
	}

	renderLoginTable = (loginHeadings, videoPlayCounters, summarizedBy) => {
		let headings = []
		headings =
			summarizedBy === 'State'
				? ['Date', 'State', 'Logins', 'userType', 'Day']
				: loginHeadings
		var counters
		if (
			summarizedBy === 'State' &&
			videoPlayCounters &&
			videoPlayCounters.length > 0
		) {
			var counters = []
			const uniqueDates = []
			const uniqueStates = []
			let day
			const userType = ['', 'guest']
			for (let i = 0;i < videoPlayCounters.length;i++) {
				if (uniqueDates.includes(videoPlayCounters[i].Date) === false) {
					uniqueDates.push(videoPlayCounters[i].Date)
				}

				if (uniqueStates.includes(videoPlayCounters[i].State) === false) {
					uniqueStates.push(videoPlayCounters[i].State)
				}
			}

			for (const date of uniqueDates) {
				for (const state of uniqueStates) {
					for (const type of userType) {
						let totalLogins = 0
						for (const counter of videoPlayCounters) {
							if (
								counter.Date === date &&
								counter.State === state &&
								counter.userType === type
							) {
								totalLogins += counter.logins
								day = counter.Day
							}
						}

						if (totalLogins > 0) {
							const newItem = {}
							newItem.logins = totalLogins
							newItem.Day = day
							newItem.State = state
							newItem.Date = date
							newItem.userType = type

							counters.push(newItem)
						}
					}
				}
			}
		} else {
			counters = videoPlayCounters
		}

		return (
			<Table striped bordered hover>
				<thead>
					<tr>
						{headings.map(head => (
							<>
								{head == 'Active Users' ? (
									this.state.displayActiveUsersCount ? (
										<th className='tableRowStyle'>{head}</th>
									) : (
										''
									)
								) : (
									<th className='tableRowStyle'>{head}</th>
								)}
							</>
						))}
					</tr>
				</thead>
				<tbody>
					{counters &&
						counters.map(row => this.renderLoginTableRow(row, summarizedBy))}
				</tbody>
			</Table>
		)
	}

	renderLoginTableRow = (item, summarizedBy) => {
		const displaydistrict = summarizedBy === 'State' ? 'none' : 'block'
		const day = item.Day
			? item.Day.charAt(0).toUpperCase() + item.Day.slice(1)
			: null

		return (
			<tr>
				<td className='tdCellStyle'>{item.Date}</td>
				<td className='tdCellStyle'>{item.State}</td>
				<td
					style={{
						fontSize: '12px',
						minWidth: '100px',
						display: displaydistrict,
					}}
				>
					{item.District}
				</td>
				<td className='tdCellStyle'>{item.logins}</td>
				<td className='tdCellStyle'>{item.userType}</td>
				<td className='tdCellStyle'>{day}</td>
			</tr>
		)
	}

	renderTotalLogins = (videoPlayCounters, summarizedBy) => {
		let totalLogins = 0
		{
			videoPlayCounters &&
				videoPlayCounters.map(item => {
					totalLogins += item.logins
				})
		}

		const displaycolumn = summarizedBy === 'State' ? 'none' : 'block'
		return (
			<Table striped bordered hover>
				<thead>
					<td className='tdCellStyle'></td>
					<td className='tdCellStyle'></td>
					<td
						style={{
							fontSize: '12px',
							minWidth: '100px',
							display: displaycolumn,
						}}
					>
						{' '}
					</td>
					<td className='tdCellStyle'>Total: {totalLogins}</td>
					<td className='tdCellStyle'></td>
					<td className='tdCellStyle'></td>
				</thead>
			</Table>
		)
	}

	changeFeedType = (currentFeedType, feedType) => {
		let isfilteredWithLocations; let selectedLanguage
		if (feedType === 'Login' || this.state.selectedState !== '') {
			isfilteredWithLocations = true
			selectedLanguage = ''
		} else {
			if (
				this.state.selectedState !== '' &&
				this.state.selectedDistrict !== ''
			) {
				isfilteredWithLocations = false
			} else if (
				this.state.selectedState !== '' &&
				this.state.selectedDistrict === ''
			) {
				isfilteredWithLocations = true
			} else {
				isfilteredWithLocations = false
			}

			selectedLanguage = this.state.appLanguage
		}

		this.setState(
			{
				selectedFeedType: feedType,
				isfilteredWithLocations,
				dateRangeFilter: false,
				dateSelection: { onDate: '' },
				dateRangeSelection: { fromDate: '', toDate: '' },
				dayName: '',
				selectedLang: selectedLanguage,
				showDatePicker: false,
				showDatePickerAtToDate: false,
				showDatePickerAtFromDate: false,
				// videoPlayCounters: [],
				contentCategory: '',
				summarizedBy: '',
			},
			() => {
				this.ListVideoPlayCounters()
			},
		)
	}

	selectDay = e => {
		let isfiltered =
			Boolean(this.state.isfilteredWithLocations === true &&
				this.selectedFeedType !== 'Login')
		if (e.target.value === 'None') {
			isfiltered = this.selectedFeedType === 'Login'
			this.setState({ dayName: '', filtered: isfiltered })
		} else {
			this.setState({ dayName: e.target.value, filtered: true })
		}
	}

	changeLanguage = (currentLanguage, language) => {
		this.setState({
			selectedLang: language,
			filtered: true,
			videoPlayCounters: [],
		})
	}

	renderCategories = () => {
		const { categories } = this.state
		return (
			<div className='row'>
				<div>
					<text htmlFor='text'>Selected Categories : </text>
					<text>{this.state.contentCategory}</text>
				</div>
				<div>
					{categories.map((category, categoryIndex) => (
						<section className='container'>
							{category.options ? (
								<div key={categoryIndex} className='ac'>
									<input
										className='ac-input'
										id={category.heading + category.id + categoryIndex}
										name={category.heading + category.id + categoryIndex}
										type='checkbox'
									/>
									<label
										className='ac-label'
										htmlFor={category.heading + category.id + categoryIndex}
									>
										{category.heading}
									</label>
									<article className='ac-text'>
										{category.options &&
											category.options.map((level, levelIndex) => (
												<div key={levelIndex}>
													{level.options ? (
														<div className='ac-sub'>
															<input
																className='ac-input'
																id={
																	level.heading + category.heading + levelIndex
																}
																name={
																	level.heading + category.heading + levelIndex
																}
																type='checkbox'
															/>
															<label
																className='ac-label'
																htmlFor={
																	level.heading + category.heading + levelIndex
																}
															>
																{level.heading}
															</label>

															{level.options &&
																level.options.map((sublevel, sublevelIndex) => (
																	<article
																		key={sublevelIndex}
																		className='ac-sub-text'
																	>
																		<p
																			onClick={
																				() =>
																					this.setItemSelected(
																						category.heading,
																						level.heading,
																						sublevel.heading,
																					)
																				// this.setState({ contentCategory: sublevel.heading })
																			}
																		>
																			{sublevel.heading}
																		</p>
																	</article>
																))}
														</div>
													) : (
														<label
															onClick={
																() =>
																	this.setItemSelected(
																		category.heading,
																		level.heading,
																		'',
																	)
																// this.setState({ contentCategory: level.heading })
															}
															htmlFor={
																level.heading + category.heading + levelIndex
															}
														>
															{level.heading}
														</label>
													)}
												</div>
											))}
									</article>
								</div>
							) : (
								<label
									onClick={
										() => this.setItemSelected(category.heading, '', '')
										// this.setState({ contentCategory: category.heading })
									}
									htmlFor={category.heading + category.id + categoryIndex}
								>
									{category.heading}
								</label>
							)}
						</section>
					))}
				</div>
			</div>
		)
	}

	setItemSelected = (category, level, sublevel) => {
		const categoryData = category ? category : ''
		const levelData = level && level != 'All' ? level : ''
		const sublevelData = sublevel && sublevel != 'All' ? sublevel : ''
		const selectedCategory =
			sublevelData != ''
				? sublevelData
				: levelData != ''
					? levelData
					: categoryData
		this.setState({
			contentCategory: selectedCategory.trim(),
			videoPlayCounters: [],
		})
	}

	closeModal = () => {
		this.setState({ modalVisible: false })
	}

	openTimePicker = () => {
		this.setState({ showDatePicker: true })
	}

	getFormattedDate = onDate => {
		let date = onDate.getDate()
		let month = onDate.getMonth() + 1
		const year = onDate.getFullYear()
		if (date < 10) {
			date = '0' + date
		}

		if (month < 10) {
			month = '0' + month
		}

		const formattedDate = date + '/' + month + '/' + year
		return formattedDate
	}

	handleDateSelection = date => {
		const newDate = date.range1.startDate
		const formattedDate = this.getFormattedDate(newDate)
		this.setState({
			dateSelection: { onDate: formattedDate },
			showDatePicker: false,
			filtered: true,
		})
	}

	openTimePickerAtFromDate = () => {
		this.setState({ showDatePickerAtFromDate: true })
	}

	handleFromDateSelection = fromDate => {
		const newFromDate = fromDate.range1.startDate
		const formattedFromDate = this.getFormattedDate(newFromDate)
		this.setState({
			dateRangeSelection: {
				fromDate: formattedFromDate,
				toDate: this.state.dateRangeSelection.toDate,
			},
			showDatePickerAtFromDate: false,
			dateRangeFilter: true,
			filtered: true,
		})
	}

	openTimePickerAtToDate = () => {
		this.setState({ showDatePickerAtToDate: true })
	}

	handleToDateSelection = toDate => {
		const newToDate = toDate.range1.startDate
		const formattedToDate = this.getFormattedDate(newToDate)
		this.setState({
			dateRangeSelection: {
				fromDate: this.state.dateRangeSelection.fromDate,
				toDate: formattedToDate,
			},
			showDatePickerAtToDate: false,
			filtered: true,
		})
	}

	handleChange = location => {
		let isfilteredWithLocations; let filtered; let district
		district =
			location.district === 'All' || location.district === 'None'
				? ''
				: location.district
		const state = location.stateCodec === 'Others' ? '' : location.stateCodec

		if (state === '' && this.state.selectedFeedType !== 'Login') {
			// let data = []
			isfilteredWithLocations = false
			if (
				(this.state.dateRangeSelection.fromDate !== '' &&
					this.state.dateRangeSelection.toDate !== '') ||
				this.state.dateSelection.onDate !== '' ||
				this.state.dayName !== ''
			) {
				filtered = true
			} else {
				filtered = false
			}
		} else if (state !== '' && this.state.selectedFeedType !== 'Login') {
			isfilteredWithLocations = true
			filtered = true
		} else if (state === '' && this.state.selectedFeedType === 'Login') {
			// let data = []
			isfilteredWithLocations = true
			filtered = false
		} else if (state !== '' && this.state.selectedFeedType === 'Login') {
			isfilteredWithLocations = true
			filtered = true
		}

		this.setState({
			selectedState: state,
			selectedDistrict: district,
			selectedLang: '',
			filtered,
			isfilteredWithLocations,
			contentCategory: '',
			videoPlayCounters: [],
			summarizedBy: '',
			// dataFound: false,
		})
	}

	changeOption = (currentOption, option) => {
		this.setState({
			summarizedBy: option,
			filtered: true,
			videoPlayCounters: [],
		})
	}

	resetFilter = async () => {
		this.setState({
			selectedFeedType: 'Content',
			dateSelection: {
				onDate: '',
			},
			selectedLang: '',
			dayName: '',
			dateRangeSelection: {
				fromDate: '',
				toDate: '',
			},
			dateRangeFilter: false,
			filtered: false,
			dataFound: false,
			contentCategory: '',
			summarizedBy: '',
		})
	}

	render() {
		const {
			loginHeadings,
			isfilteredWithLocations,
			locationContentHeadings,
			locationVideoHeadings,
			contentHeadings,
			videoHeadings,
			teluguContentHeadings,
			hindiContentHeadings,
			englishContentHeadings,
			videoPlayCounters,
			feedTypeOptions,
			selectedFeedType,
			dayName,
			languageOptions,
			selectedLang,
			showDatePicker,
			dateSelection,
			showDatePickerAtFromDate,
			dateRangeSelection,
			showDatePickerAtToDate,
			filtered,
			dataFound,
			contentCategory,
			modalVisible,
			summarizedBy,
			loading,
		} = this.state
		const GroupedOptions = [
			{
				label: 'Others',
				options: this.state.OtherOptions,
			},
			{
				label: 'TG',
				options: this.state.TGLocations,
			},
			{
				label: 'AP',
				options: this.state.APLocations,
			},
		]

		const colourStyles = {
			option(styles, { data, isDisabled, isFocused, isSelected }) {
				return {
					...styles,
					backgroundColor: isFocused ? '#1E90FF' : null,
					color: 'black',
				}
			},
			menu: provided => ({ ...provided, zIndex: 9999 }),
		}
		const summarizeLocationOptions = [
			{
				label: 'State',
				value: 'State',
				id: 0,
			},
			{
				label: 'District',
				value: 'District',
				id: 1,
			},
		]
		// const defaultStateValue = this.state.defaultValue === true ? this.state.OtherOptions : null
		return (
			<section className='feed'>
				{loading ? <Spinner /> : null}
				{this.state.selectedFeedType !== 'Login' ? (
					<Header
						changeAppLanguage={this.changeAppLanguage}
						appLanguage={this.state.appLanguage}
					/>
				) : null}

				<div>
					<label>Video Play Counters</label>
				</div>
				<div>
					<div className='row' style={{ marginBottom: 5 }}>
						<text>Choose Report Type : </text>
						{feedTypeOptions.map(item => (
							<div className='col-md-2'>
								<input
									value={selectedFeedType}
									type='checkbox'
									checked={this.state.selectedFeedType == item.label}
									onChange={() => {
										this.changeFeedType(
											this.state.selectedFeedType,
											item.label,
										)
									}}
								></input>
								<text htmlFor={item.label}>{item.label}</text>
							</div>
						))}
					</div>

					<div className='newrow col-md-6' style={{ marginBottom: 5 }}>
						<text> Show State and Districts : </text>

						<Select
							options={GroupedOptions}
							onChange={this.handleChange}
							styles={colourStyles}
							defaultValue={this.state.OtherOptions}
						/>
					</div>

					{selectedFeedType === 'Login' ? (
						<div className='newrow' style={{ marginBottom: 5 }}>
							<text> Summarize By : </text>

							{summarizeLocationOptions.map(item => (
								<div className='col-md-3'>
									<input
										value={summarizedBy}
										type='radio'
										checked={this.state.summarizedBy == item.label}
										onChange={() => {
											this.changeOption(this.state.summarizedBy, item.label)
										}}
									></input>
									<text htmlFor={item.label}>{item.label}</text>
								</div>
							))}
						</div>
					) : null}

					<div className='row1' style={{ marginBottom: 5 }}>
						<text htmlFor='dayName'> Day : </text>
						<select
							onChange={e => {
								this.selectDay(e)
							}}
						>
							{this.dayName.map((item, index) => (
								<option
									value={item}
									selected={dayName == item}
								>
									{item}
								</option>
							))}
						</select>
					</div>

					{selectedFeedType === 'Content' &&
						isfilteredWithLocations === false ? (
						<div className='row3' style={{ marginBottom: 5 }}>
							<text>Choose Category : </text>
							<input
								type='text'
								onClick={() => {
									this.setState({ modalVisible: true })
								}}
								value={this.state.contentCategory}
								placeholder='Choose Category'
							></input>
							<Modal show={modalVisible} onHide={() => this.closeModal()}>
								<Modal.Body>{this.renderCategories()}</Modal.Body>
								<Modal.Footer>
									<Button onClick={() => this.closeModal()}>Ok</Button>
								</Modal.Footer>
							</Modal>
						</div>
					) : null}
					<div className='row4' style={{ marginBottom: 5 }}>
						<text>OnDate : </text>
						<input
							type='text'
							onClick={() => {
								this.openTimePicker()
							}}
							value={dateSelection.onDate}
							placeholder='Choose Date'
						></input>
						{showDatePicker ? (
							<DateRangePicker
								ranges={[dateSelection]}
								onChange={this.handleDateSelection}
							/>
						) : null}
					</div>
					<div className='row5' style={{ marginBottom: 5 }}>
						<text>FromDate : </text>
						<input
							type='text'
							onClick={() => {
								this.openTimePickerAtFromDate()
							}}
							value={dateRangeSelection.fromDate}
							placeholder='Choose From Date'
						></input>
						{showDatePickerAtFromDate ? (
							<DateRangePicker
								ranges={[dateRangeSelection]}
								onChange={this.handleFromDateSelection}
							/>
						) : null}
						<div style={{ display: 'inline-block' }}>
							<text style={{ marginLeft: 50 }}>ToDate : </text>
							<input
								type='text'
								onClick={() => {
									this.openTimePickerAtToDate()
								}}
								value={dateRangeSelection.toDate}
								placeholder='Choose To Date'
							></input>
							{showDatePickerAtToDate ? (
								<DateRangePicker
									ranges={[dateRangeSelection]}
									onChange={this.handleToDateSelection}
								/>
							) : null}
						</div>
					</div>
					<div className='row6' style={{ marginBottom: 5 }}>
						<Button
							style={{ marginRight: 10 }}
							onClick={() => {
								this.ListVideoPlayCounters()
							}}
						>
							Filter
						</Button>
						<Button
							onClick={() => {
								this.resetFilter()
							}}
						>
							Reset
						</Button>
					</div>
				</div>
				{this.state.selectedFeedType === 'Content' &&
					this.state.selectedLang === '' &&
					isfilteredWithLocations === false &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderContentTable(contentHeadings, videoPlayCounters)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : this.state.selectedFeedType === 'Video' &&
					this.state.selectedLang === '' &&
					isfilteredWithLocations === false &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderVideoTable(videoHeadings, videoPlayCounters)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : this.state.selectedFeedType === 'Login' &&
					isfilteredWithLocations === true &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderLoginTable(
								loginHeadings,
								videoPlayCounters,
								summarizedBy,
							)}
							{videoPlayCounters && videoPlayCounters.length > 0
								? this.renderTotalLogins(videoPlayCounters, summarizedBy)
								: null}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : null}
				{this.state.selectedState === '' &&
					this.state.selectedFeedType === 'Content' &&
					this.state.selectedLang === 'Telugu' &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderTeluguContentTable(
								teluguContentHeadings,
								videoPlayCounters,
							)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : this.state.selectedFeedType === 'Content' &&
					this.state.selectedLang === 'Hindi' &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderHindiContentTable(
								hindiContentHeadings,
								videoPlayCounters,
							)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : this.state.selectedFeedType === 'Content' &&
					this.state.selectedLang === 'English' &&
					contentCategory === '' ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderEnglishContentTable(
								englishContentHeadings,
								videoPlayCounters,
							)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : null}
				{/* Video With Language */}
				{this.state.selectedState === '' &&
					this.state.selectedFeedType === 'Video' &&
					this.state.selectedLang !== '' ? (
					this.state.dataFound === true ? (
						<ListVideosByLanguage
							feedType={this.state.selectedFeedType}
							selectedLang={this.state.selectedLang}
							appLang={this.state.appLanguage}
							availableData={this.state.dataFound}
							ListVideoPlayCounters={this.state.videoPlayCounters}
						/>
					) : (
						<div>No Data To Display</div>
					)
				) : this.state.selectedFeedType === 'Videos' &&
					this.state.selectedLang !== '' ? (
					this.state.dataFound === true ? (
						<ListVideosByLanguage
							feedType={this.state.selectedFeedType}
							selectedLang={this.state.selectedLang}
							appLang={this.state.appLanguage}
							availableData={this.state.dataFound}
							ListVideoPlayCounters={this.state.videoPlayCounters}
						/>
					) : (
						<div>No Data To Display</div>
					)
				) : null}

				{/* Here if the type is Jobs then render the listJobsContainer */}
				{this.state.selectedFeedType === 'Jobs' &&
					this.state.selectedLang !== '' ? (
					this.state.dataFound === true ? (
						<ListJobsCounters
							feedType={this.state.selectedFeedType}
							selectedLang={this.state.selectedLang}
							appLang={this.state.appLanguage}
							availableData={this.state.dataFound}
							ListVideoPlayCounters={this.state.videoPlayCounters}
						/>
					) : (
						<div>No Data To Display</div>
					)
				) : null}

				{isfilteredWithLocations === true &&
					this.state.selectedState !== '' &&
					selectedFeedType !== 'Login' &&
					this.state.selectedState !== '' &&
					contentCategory === '' ? (
					selectedFeedType === 'Content' && this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderLocationContentTable(
								locationContentHeadings,
								videoPlayCounters,
							)}
						</div>
					) : selectedFeedType === 'Video' && this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderLocationVideoTable(
								locationVideoHeadings,
								videoPlayCounters,
							)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : null}
				{this.state.contentCategory !== '' &&
					selectedFeedType === 'Content' &&
					isfilteredWithLocations === false ? (
					this.state.dataFound === true ? (
						<div style={{ marginTop: 10 }}>
							{this.renderContentCategoriesTable(
								contentCategory,
								videoPlayCounters,
							)}
						</div>
					) : (
						<div>No Data To Display</div>
					)
				) : null}
			</section>
		)
	}
}

export default VideoPlayCounters
